/**
 * Lights up words progressively while the section travels through the viewport.
 * Listens to scroll only while visible; work is throttled to one frame.
 */
class TextReveal extends HTMLElement {
  connectedCallback() {
    this.words = Array.from(this.querySelectorAll('.text-reveal__word'));
    if (!this.words.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.start = (Number(this.dataset.start) || 85) / 100;
    this.end = (Number(this.dataset.end) || 35) / 100;
    this.onScroll = this.onScroll.bind(this);
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      } else {
        window.removeEventListener('scroll', this.onScroll);
      }
    });
    this.observer.observe(this);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('scroll', this.onScroll);
  }
  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight;
      // 0 when the section's center is at `start` of the viewport, 1 when it reaches `end`.
      const center = rect.top + rect.height / 2;
      const from = vh * this.start;
      const to = vh * this.end;
      const progress = Math.min(1, Math.max(0, (from - center) / (from - to)));
      const lit = Math.round(progress * this.words.length);
      this.words.forEach((word, i) => word.classList.toggle('is-lit', i < lit));
    });
  }
}
if (!customElements.get('text-reveal')) customElements.define('text-reveal', TextReveal);
